import React, { useState, useEffect } from 'react'
import { Form, FormControl} from "react-bootstrap";
import { useNavigate , useLocation, useSearchParams} from 'react-router-dom';
import LoginService from '../services/LoginService';
import {useAuth} from '../context/AuthContext';
import ErrorComponent from './ErrorComponent';

const LoginComponent = (props) => {
    const { setUser } = useAuth();
    const { user } = useAuth();
    const [searchParams] = useSearchParams();
    let [username, setUsername] = useState("");
    let [password, setPassword] = useState("");
    let [unauthorized, setUnauthorized] = useState(false);
    const navigate = useNavigate();
    let location = useLocation();

    let from = location.state != null && location.state.from != null ? location.state.from : "/tracks";
    let haveToLogin = location.state != null && location.state.from != null ? true : false;

    useEffect(() => {
        let sessionUser = localStorage.getItem("user")
        
        if(user !== null) {
            navigate("tracks");
        }
        if(sessionUser !== null && sessionUser !== "null") {
            setUser(localStorage.getItem("user"));
            navigate("tracks");
        }
    }, []);

    // to Login with JWT Key from GS-Oauth Client
    useEffect(() => {
        if(searchParams.get('Authorization')){
            LoginService.loadJWT(searchParams.get('Authorization')).then(
                function(value) {
                    if(value.data.jwt !== null) {
                        setUser(value.data.jwt);
                        localStorage.setItem("user", value.data.jwt);
                        navigate(from)
                    }
                }
            )
        }
    },[searchParams])

    

    const handlePasswordInput = event => {
        setPassword(event.target.value);
    };

    const handleUsernameInput = event => {
        setUsername(event.target.value);
    };

    const handleLoginSubmit = () => {
        LoginService.getJWT(username, password).then(
            function(value) {
                if(value.data.jwt != null) {
                    setUser(value.data.jwt);
                    localStorage.setItem("user", value.data.jwt);
                    navigate(from)
                }
                else {
                    setUser(null);
                    setUnauthorized(true);
                }
            },
            function(error) {
                setUser(null);
                setUnauthorized(true);
            }
        )
    };

    const handleLoginKeyUp = event => {
        event.preventDefault();
        if (event.key === 'Enter' && event.keyCode === 13) {
            handleLoginSubmit();
        }
    }

    const handleFormSubmit = e => e.preventDefault();
   
    let errorText = "Kein Zugriff! Bitte einloggen"

    const url = process.env.OAUTH2_CLIENT_URL?process.env.OAUTH2_CLIENT_URL:"https://oauthtest.case-gs.eu";

    return (
    <div className="login">
        {haveToLogin &&
            <ErrorComponent text={errorText}></ErrorComponent>
        }
        <h1 className="title">
        Login
        </h1>
        <Form inline="true" onSubmit={handleFormSubmit}>
                <FormControl 
                    onChange={handleUsernameInput}
                    value={username}
                    type="text"
                    placeholder="Benutzername"
                    className="mr-sm-12"
                />

            <FormControl
                    onChange={handlePasswordInput}
                    value={password}
                    onKeyUp={handleLoginKeyUp}
                    type="password"
                    placeholder="Passwort"
                    className="mr-sm-12"
                />
        </Form>
        {unauthorized &&
            <ErrorComponent text={"Benutzername oder Passwort falsch!"}></ErrorComponent>
        }        
        <button onClick={handleLoginSubmit} className="btn btn-info">Login </button>
        
        <a style={{"width" :"100%", "marginTop" : "30px"}} className="btn btn-link" href={url + "/auth/signIn/lst"} >Login Leistelle Tirol</a>
        

    </div>
   )
  }
  
  export default LoginComponent



